import { combineReducers } from 'redux';
import filters from './filtersReducer';
import selectedDate from './selectedDateReducer';
import userMessages from './userMessagesReducer';
import treatmentInstanceSorting from './treatmentInstanceSortingReducer';
import availableDatePeriod from './availableDatePeriod';
import schedulerMapView from './schedulerMapView';
import clinicianPlan from './clinicianPlan';
import autoAllocate from './autoAllocateReducer';
import assignmentInfo from './assignmentInfoReducer';
import scheduler from './scheduler';
import assignmentDistanceInfo from './assignmentDistanceInfoReducer';
import assignmentDistanceMessages from './assignmentDistanceMessagesReducer';
import moreOptions from './moreOptionsReducer';

const dailyPlanning = combineReducers({
  selectedDate,
  filters,
  userMessages,
  treatmentInstanceSorting,
  availableDatePeriod,
  schedulerMapView,
  clinicianPlan,
  autoAllocate,
  assignmentInfo,
  assignmentDistanceInfo,
  scheduler,
  assignmentDistanceMessages,
  moreOptions,
});

export default dailyPlanning;
